import React, { useState } from "react";
import Footer from "../component/Footer";
import HeaderHome from "../component/HeaderHome";
import FAQBanner from "../assets/img/Blog/faqBanner.png";
import faq from "../assets/img/Blog/Vector 355.png";

const faqs = [
  {
    q: "How much work is available?",
    a: "There are plenty of opportunities! As a partner in the National Clinical Staffing Framework, we offer assignments throughout the UK for Nurses, Allied Health, and Healthcare Professionals in various NHS Trusts. We also work with top private healthcare organisations and blue-chip companies across the country.",
  },
  {
    q: "Do you offer longer placements?",
    a: "Yes, we do! We can set up fixed-term assignments that last anywhere from 1 to 12 months. If you're looking for a long-term position, we'll help you find the right job that fits your needs.",
  },
  {
    q: "How much will I get paid?",
    a: "In the current economic climate, competitive pay is essential. We provide excellent rates that depend on your role, chosen shifts, and the client you work with. During your interview, we will clearly explain the pay rates for all shift patterns before confirming any assignment.",
  },
  {
    q: "How will I get paid?",
    a: "You have options! You can choose to receive payments through PAYE or via an umbrella company. We ensure timely payments, so shifts worked in one week are paid the following Friday.",
  },
  {
    q: "What’s an umbrella company?",
    a: "An umbrella company serves as an intermediary for processing payroll for temporary workers. They manage PAYE, National Insurance contributions, and holiday pay, complying with the National Minimum Wage. Unlike traditional employers, they do charge for these services.",
  },
  {
    q: "How many hours am I expected to work?",
    a: "The choice is yours! With a variety of clients, we offer a flexible schedule. Just let us know your availability, and we’ll find shifts that work for you.",
  },
  {
    q: "Do I have to commit to a set number of hours?",
    a: "No commitment is necessary! Our flexible approach allows you to choose shift patterns that align with your lifestyle and commitments, giving you the freedom to be your own boss.",
  },
];

const Blog = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-gray-50">
      <HeaderHome />

      <div className="relative mt-8">
        <img
          className="w-full min-h-[200px] md:min-h-[298px] object-cover"
          src={FAQBanner}
          alt="FAQ Banner"
        />
        <div className="absolute inset-0 flex items-center justify-start px-4 md:px-12 text-white">
          <h1 className="font-oregon_black text-[20px] font-medium tracking-wider sm:text-[30px] ld:text-[32px]">
            Your questions matter to us.
          </h1>
        </div>
      </div>

      <div className="px-4 md:px-12 mt-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 font-oregon">
          Frequently asked questions
        </h2>
      </div>

      <div className="px-4 md:px-12 flex flex-col lg:flex-row gap-8 mb-16">
        <div className="w-full lg:w-[65%]">
          {faqs.map((item, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-lg mb-4 p-4 border border-gray-200"
            >
              <div
                onClick={() => toggleAnswer(index)}
                className="flex justify-between items-center cursor-pointer"
              >
                <p className="font-semibold text-base md:text-lg font-corpo">{item.q}</p>
                <button className="text-2xl font-bold focus:outline-none text-[#3D3D3D]">
                  {openIndex === index ? "−" : "+"}
                </button>
              </div>
              {openIndex === index && (
                <p className="mt-3 text-[#8A94A6] font-corpo transition-all duration-300 text-sm md:text-base">
                  {item.a}
                </p>
              )}
            </div>
          ))}
        </div>

        <div className="w-full lg:w-[35%]">
  <div className="bg-white shadow-lg rounded-xl h-[420px] flex items-center justify-center p-6">
    <div className="flex flex-col items-center text-center">
      <img
        src={faq}
        alt="FAQ Illustration"
        className="max-w-full h-auto mb-4"
      />
      <h3 className="text-lg font-bold mb-2 font-corpo">Do you have more questions?</h3>
      <p className="text-sm px-4 md:px-8 font-corpo text-[#8A94A6]">
        End-to-end payments and financial management in a single solution. Meet
        the right platform to help realize.
      </p>

      <div className="w-[70%] mt-6">
         <a
  href="mailto:care@rhc360.com"
  className="w-full text-white bg-[#0082DA] py-5 px-2 xl:px-10 hover:bg-blue-700 transition-all text-center block"
>
  Shoot a Direct Mail
</a>
      </div>
     

      {/* <button className="w-[70%] mt-6 text-white bg-[#0082DA] py-5 px-2 xl:px-10 hover:bg-blue-700 transition-all">
         <a
           href="mailto:care@rhc360.com"
          >
             Shoot a Direct Mail
          </a>
      </button> */}
    </div>
  </div>
</div>

      </div>

      <Footer />
    </div>
  );
};

export default Blog;
